import { Controller } from "@hotwired/stimulus"
import Offcanvas from 'bootstrap/js/dist/offcanvas';

export default class extends Controller {

  static values = {
    generatedModules: Number,
    activeUrl: String,
  }
  static outlets = ['module-link'];
  static targets = ['offcanvas'];

  _isElementInViewport = (el) => {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }


  _scrollToActiveItem = (e) => {
    let el;
    if (e !== undefined) {
      el = e.target;
    } else {
      el = this.element;
    }

    // Find the active item with the class 'active'
    var activeItem = el.querySelector('.nav-item.active');
    window.activeItem = activeItem;

    // Scroll to the active item if found
    if (activeItem && !this._isElementInViewport(activeItem)) {
      activeItem.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  activeUrlValueChanged = (value) => {
    if(!value) return;
    this.moduleLinkOutlets.forEach((link) => {
      link.isActiveValue = link.viewUrlValue === value || link.generateUrlValue === value;
    })
  }

  moduleLinkOutletConnected = (outlet, element) => {
    element.addEventListener('click', (target) => {
      if (target.ctrlKey || target.metaKey) return;

      this.activeUrlValue = new URL(target.target.href).pathname;

      Offcanvas.getOrCreateInstance(this.offcanvasTarget).hide();
    });
  }

  offcanvasTargetConnected = (element) => {
    element.addEventListener('show.bs.offcanvas', this._scrollToActiveItem);
  }

  connect() {

    this.activeUrlValue = new URL(window.location.href).pathname;

    this._scrollToActiveItem();
    // document.documentElement.addEventListener('turbo:load', this._scrollToActiveItem.bind(this));

    // Tracking change of module content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.target.id == 'module-content' &&
          mutation.attributeName == 'src' &&
          mutation.oldValue !== mutation.target.getAttribute('src')
        ) {
          this.activeUrlValue = new URL(mutation.target.getAttribute('src')).pathname;

          document
            .querySelector('#module-content')
            ?.scrollIntoView();

          // Fetch the endpoint to mark this as current module
          fetch(mutation.target.getAttribute('src') + 'open/');
        }
      });
    });
    observer.observe(document.querySelector('turbo-frame#module-content'), {
      attributes: true, //configure it to listen to attribute changes
      attributeOldValue: true
    });

    // Open the navigation offcanvas if the offcanvas available and there are one or less generated modules
    const course_navigation_button = document.querySelector('.btn-open-course-plan-mobile');
    const mobile_navigation_is_available = window.getComputedStyle(course_navigation_button).display === 'flex';
    const offcanvas_container = this.offcanvasTarget;
    const offcanvas_visible = offcanvas_container.classList.contains('show');

    if (mobile_navigation_is_available &&
      this.generatedModulesValue <= 1 &&
      !offcanvas_visible &&
      !document.querySelector('html').hasAttribute('data-turbo-preview')
    ) {
      course_navigation_button.click();
    }
  }
}
